export enum FeedbackSource {
    FRONTEND = 1,
    DASHBOARD = 2
}

export enum FeedbackType {
    BUG = 1,
    FEEDBACK = 2
}
